import ProductImage from '@assets/png/product.png';
import { Image } from '@mantine/core';
import { IFieldConfiguration } from '@models/FieldConfiguration.model';
import { IEquipmentInventory } from '@models/EquipmentInventory.model';
import { getEquipmentValue } from '@utils';
import { AssetMatchLabel, StatusBadge } from '@components/index';
import { IUserMember } from '@services/queries/studios/getUserMembers/getUserMembers';
import React from 'react';
import { TextProps } from '@components/Text/Text';
import { EquipmentIdentificationStatus } from '@models/Equipment.model';
import {
  Avatar,
  ImagePlaceholder,
  Label,
  PlaceholderDiv,
  User,
  CellTextText,
} from '../ListProducts.styles';

const CellText = (props: React.PropsWithChildren<TextProps>) => {
  const { children, ...rest } = props;
  return (
    <CellTextText text="p200" textColor="n903" {...rest}>
      {children}
    </CellTextText>
  );
};
export const EmptyText = (props: React.PropsWithChildren<TextProps>) => {
  const { children, ...rest } = props;
  return (
    <CellText italic textColor="n500" {...rest}>
      {children}
    </CellText>
  );
};

export function getCell(
  headerItem: IFieldConfiguration,
  item: IEquipmentInventory,
  index: number,
  members: IUserMember[],
  isMobile: boolean,
): React.ReactNode {
  const value = getEquipmentValue(headerItem, item);
  let withImage = <></>;
  let valueRender = <></>;

  let text: TextProps['text'] = 'p200';
  let imgSize: number | undefined;
  if (isMobile) {
    imgSize = 20;
    text = 'p100';
  }

  if (index === 0) {
    withImage = item.product.imageUrl ? (
      <Image
        src={item.product.imageUrl}
        alt=""
        width={imgSize}
        height={imgSize}
        withPlaceholder
        placeholder={
          <PlaceholderDiv>
            <Image
              src={item.manufacturerImg ? item.manufacturerImg : ProductImage}
              alt=""
              width={imgSize}
              height={imgSize}
              styles={() => ({
                image: {
                  borderRadius: '0',
                },
                imageWrapper: {
                  borderRadius: '0',
                },
              })}
              withPlaceholder
              placeholder={
                <ImagePlaceholder
                  className="defaultImage"
                  src={ProductImage}
                  alt=""
                />
              }
            />
          </PlaceholderDiv>
        }
      />
    ) : (
      <Image
        src={item.manufacturerImg ? item.manufacturerImg : ProductImage}
        alt=""
        width={imgSize}
        height={imgSize}
        withPlaceholder
        placeholder={
          <ImagePlaceholder
            className="defaultImage"
            src={ProductImage}
            alt=""
          />
        }
      />
    );
  }

  if (typeof value === 'string') {
    valueRender = <CellText text={text}>{value}</CellText>;
  }

  // Is string
  if (headerItem.fieldName === 'userName') {
    const findAuth0User = members.find(
      userItem => userItem.id === item.user?.id,
    );
    valueRender = (
      <User>
        {findAuth0User && <Avatar src={findAuth0User.picture} alt="avatar" />}
        <CellText text={text}>{item.user?.name}</CellText>
      </User>
    );
  }

  if (!value) {
    valueRender = <EmptyText text={text}>Empty</EmptyText>;
  }

  // Handles empty
  if (headerItem.fieldName === 'identificationStatus') {
    valueRender = (
      <AssetMatchLabel
        status={value as EquipmentIdentificationStatus | ''}
        text={text}
      />
    );
  }

  if (headerItem.fieldName === 'equipmentStatusName') {
    valueRender = (
      <StatusBadge
        label={
          item.equipmentStatus
            ? item.equipmentStatus.category
            : 'Decommissioned'
        }
        name={item.equipmentStatus?.name}
        fontColor="#1a1b1c"
      />
    );
  }

  return (
    <Label>
      {withImage}
      {valueRender}
    </Label>
  );
}
